// Popup.tsx
import React from "react";
import "./Popup.css";

interface PopupProps {
  isOpen: boolean;
  onBackButton: () => void;
  popupHeader: string;
  content: React.ReactNode;
  
}

const Popup: React.FC<PopupProps> = ({
  isOpen,
  onBackButton,
  popupHeader,
  content,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h2 className="popup-title">{popupHeader}</h2>
        </div>
        <div className="popup-body">{content}</div>
        <div className="popup-footer">
          <button className="popup-back" onClick={onBackButton}>
            <span className="popup-back-arrow">←</span>
            <span className="popup-back-text">Back</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
